import { Response } from 'app/api/Response';
import UserApi from 'app/api/UserApi';
import { useFormik } from 'formik';
import { useMeDetailsQuery } from 'legoland-sdk/dist/experimental';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { Box, Button, FormGroup, RadioGroup, VGrid, useToasts } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const clockFormats = ['24', '12'];
const dateFormats = ['DDMMYYYY', 'MMDDYYYY'];
const units = ['KM', 'MI'];
const weekStarts = ['MONDAY', 'SUNDAY'];
const valueToOption = value => ({
  label: value,
  value
});
const arrayToOptions = array => array.map(valueToOption);
const defaultValues = {
  clockFormat: '24',
  dateFormat: 'DDMMYYYY',
  units: 'KM',
  weekStart: 'MONDAY'
};
const UserSettingsForm = layoutProps => {
  const {
    addToast
  } = useToasts();
  const queryClient = useQueryClient();
  const meDetailsQuery = useMeDetailsQuery();
  const self = meDetailsQuery.data?.meDetails;
  const [initialValues, setInitialValues] = useState(defaultValues);
  useEffect(function onSelfSettingsChange() {
    setInitialValues(self?.settings || defaultValues);
  }, [self?.settings]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async values => {
      const response = await UserApi.updateSettings(values);
      queryClient.invalidateQueries(['legoland', 'users', 'me-details']);
      return Response.match(response, () => {
        addToast('Your settings are successfully updated.', 'success');
        setInitialValues(values);
      }, error => {
        console.error(error);
        addToast(error?.message ?? (typeof error === 'string' ? error : 'Error while updating your settings. Please try again.'), 'danger');
      });
    }
  });
  const getFormGroupProps = name => ({
    caption: formik.touched[name] && formik.errors[name],
    danger: Boolean(formik.touched[name] && formik.errors[name])
  });
  function getRadioGroupProps(name, options) {
    return {
      $width: '100%',
      options: options,
      variant: 'horizontal',
      ...formik.getFieldProps(name),
      onBlur: () => formik.setFieldTouched(name),
      onChange: ({
        value
      }) => formik.setFieldValue(name, value),
      value: options.find(o => o.value === formik.values[name])
    };
  }
  if (!self) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Box, {
    as: "form",
    onSubmit: formik.handleSubmit,
    ...layoutProps,
    "data-sentry-element": "Box",
    "data-sentry-component": "UserSettingsForm",
    "data-sentry-source-file": "UserSettingsForm.tsx",
    children: [/*#__PURE__*/_jsxs(VGrid, {
      justifyContent: "stretch",
      "data-sentry-element": "VGrid",
      "data-sentry-source-file": "UserSettingsForm.tsx",
      "data-sentry-element": "VGrid",
      children: [/*#__PURE__*/_jsx(FormGroup, {
        label: "Units",
        ...getFormGroupProps('units'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "UserSettingsForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(RadioGroup, {
          ...getRadioGroupProps('units', arrayToOptions(units)),
          "data-sentry-element": "RadioGroup",
          "data-sentry-source-file": "UserSettingsForm.tsx",
          "data-sentry-element": "RadioGroup"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        label: "Clock format",
        ...getFormGroupProps('clockFormat'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "UserSettingsForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(RadioGroup, {
          ...getRadioGroupProps('clockFormat', arrayToOptions(clockFormats)),
          "data-sentry-element": "RadioGroup",
          "data-sentry-source-file": "UserSettingsForm.tsx",
          "data-sentry-element": "RadioGroup"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        label: "Date format",
        ...getFormGroupProps('dateFormat'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "UserSettingsForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(RadioGroup, {
          ...getRadioGroupProps('dateFormat', arrayToOptions(dateFormats)),
          "data-sentry-element": "RadioGroup",
          "data-sentry-source-file": "UserSettingsForm.tsx",
          "data-sentry-element": "RadioGroup"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        label: "Week start",
        ...getFormGroupProps('weekStart'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "UserSettingsForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(RadioGroup, {
          ...getRadioGroupProps('weekStart', arrayToOptions(weekStarts)),
          "data-sentry-element": "RadioGroup",
          "data-sentry-source-file": "UserSettingsForm.tsx",
          "data-sentry-element": "RadioGroup"
        })
      })]
    }), /*#__PURE__*/_jsx(Button, {
      busy: formik.isSubmitting,
      disabled: !formik.dirty,
      $mt: "3sp",
      type: "submit",
      variant: "primary",
      "data-sentry-element": "Button",
      "data-sentry-source-file": "UserSettingsForm.tsx",
      "data-sentry-element": "Button",
      children: "Save settings"
    })]
  });
};
export default UserSettingsForm;